import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useSignOut } from "../../api/hooks";
import { Button } from "../control/Button";

/** DELETE /session, then the sign-in screen. */
export function SignOutButton() {
  const { t } = useTranslation("common");
  const signOut = useSignOut();
  const navigate = useNavigate();
  return (
    <Button
      variant="quiet"
      size="sm"
      busy={signOut.isPending}
      onClick={() => signOut.mutate(undefined, { onSuccess: () => navigate("/signin") })}
    >
      {t("signOut")}
    </Button>
  );
}
